// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arbitratorsContainer {
  width: 100%;
  background-color: #ffffff;
  padding: 70px 24px 80px;
}

.arbitratorsHeading {
  font-weight: 800;
  color: #172639;
  font-size: 2.5rem;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}

.arbitratorsSubheading {
  color: #6b7280;
  font-size: 1rem;
  margin-bottom: 40px;
}

.arbitratorsCards {
  max-width: 1300px;
  margin: 0 auto;
}

.arbitratorCard {
  background-color: #ffffff;
  border: 1px solid #ececec;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04);
  padding: 32px 22px;
  height: 100%;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.arbitratorCard:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 28px rgba(23, 38, 57, 0.12);
  border-color: #eaa637;
}

.arbitratorIconBox {
  width: 64px;
  height: 64px;
  background-color: #172639;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: #eaa637;
  font-size: 24px;
  transition: background-color 0.3s ease;
}

.arbitratorCard:hover .arbitratorIconBox {
  background-color: #eaa637;
  color: #172639;
}

.arbitratorName {
  font-weight: 700;
  color: #172639;
  font-size: 1.05rem;
  margin-bottom: 4px;
}

.arbitratorRole {
  display: block;
  color: #eaa637;
  font-weight: 700;
  font-size: 0.72rem;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.arbitratorDivider {
  width: 36px;
  height: 3px;
  background-color: #eaa637;
  border-radius: 2px;
  margin: 16px auto;
}

.arbitratorQualification {
  color: #172639;
  font-weight: 700;
  font-size: 0.88rem;
  margin-bottom: 4px;
}

.arbitratorMeta {
  color: #555555;
  font-size: 0.88rem;
  line-height: 1.6;
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .arbitratorsContainer {
    padding: 50px 16px 60px;
  }

  .arbitratorsHeading {
    font-size: 1.9rem;
  }

  .arbitratorsSubheading {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OurArbitrators.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".arbitratorsContainer {\n  width: 100%;\n  background-color: #ffffff;\n  padding: 70px 24px 80px;\n}\n\n.arbitratorsHeading {\n  font-weight: 800;\n  color: #172639;\n  font-size: 2.5rem;\n  letter-spacing: 0.5px;\n  margin-bottom: 12px;\n}\n\n.arbitratorsSubheading {\n  color: #6b7280;\n  font-size: 1rem;\n  margin-bottom: 40px;\n}\n\n.arbitratorsCards {\n  max-width: 1300px;\n  margin: 0 auto;\n}\n\n.arbitratorCard {\n  background-color: #ffffff;\n  border: 1px solid #ececec;\n  border-radius: 12px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04);\n  padding: 32px 22px;\n  height: 100%;\n  text-align: center;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n.arbitratorCard:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 14px 28px rgba(23, 38, 57, 0.12);\n  border-color: #eaa637;\n}\n\n.arbitratorIconBox {\n  width: 64px;\n  height: 64px;\n  background-color: #172639;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px;\n  color: #eaa637;\n  font-size: 24px;\n  transition: background-color 0.3s ease;\n}\n\n.arbitratorCard:hover .arbitratorIconBox {\n  background-color: #eaa637;\n  color: #172639;\n}\n\n.arbitratorName {\n  font-weight: 700;\n  color: #172639;\n  font-size: 1.05rem;\n  margin-bottom: 4px;\n}\n\n.arbitratorRole {\n  display: block;\n  color: #eaa637;\n  font-weight: 700;\n  font-size: 0.72rem;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.arbitratorDivider {\n  width: 36px;\n  height: 3px;\n  background-color: #eaa637;\n  border-radius: 2px;\n  margin: 16px auto;\n}\n\n.arbitratorQualification {\n  color: #172639;\n  font-weight: 700;\n  font-size: 0.88rem;\n  margin-bottom: 4px;\n}\n\n.arbitratorMeta {\n  color: #555555;\n  font-size: 0.88rem;\n  line-height: 1.6;\n  margin-bottom: 0;\n}\n\n@media (max-width: 768px) {\n  .arbitratorsContainer {\n    padding: 50px 16px 60px;\n  }\n\n  .arbitratorsHeading {\n    font-size: 1.9rem;\n  }\n\n  .arbitratorsSubheading {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
